<template>
  <el-config-provider :size="size" :z-index="zIndex" :locale="locale">
    <!-- <router-view /> -->
    <router-view></router-view>
  </el-config-provider>
</template>
<script>
import { defineComponent, onMounted } from "vue";
// import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import store from "./store";

export default defineComponent({
  components: {
    // ElConfigProvider,
  },
  setup() {
    const setVarStyle = (key, value, dom = document.documentElement) => {
      dom.style.setProperty(key, value);
    };

    onMounted(() => {
      setVarStyle("--el-color-primary", "#1890ff");
    });

    return {
      zIndex: 3000,
      size: "default",
      locale: zhCn,
    };
  },
});
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
html {
  background-color: #fff;
}
body,
html {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}
</style>
